import {useEffect, useState} from "react";
import httpService from "../services/httpService"; // your axios wrapper
import { useNavigate, Link } from "react-router-dom";
import posthog from 'posthog-js';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import { useAuthStore } from '../store/store';
import {FaArrowRightFromBracket, FaSpinner} from "react-icons/fa6";
import AnimatedImage from "../components/AnimatedImage";
import {makeSignupData} from "../utils/dummyDataGenrators";
import LogOutButtonWithConfirmModal from "../components/LogOutButtonWithConfirmModal";


const englishSpeakingCountries = [
    "United Kingdom",
    "United States of America",
    "Ireland",
    "Australia",
    "Barbados",
    "Belize",
    "Canada",
    "Grenada",
    "Jamaica",
    "Malta",
    "New Zealand",
    "Trinidad and Tobago"
];


const Register = () => {

    const [formData, setFormData] = useState({
        role: "",
        country: "",
        phone: null,
        town: "",
    });

    const [errors, setErrors] = useState({
        role: "",
        country: "",
        phone: "",
        town: "",
    });

    const navigate = useNavigate();
    const [emailSent, setEmailSent] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await httpService.post("dash/register-demographics", formData);
            // const res = {
            //     data : {
            //         "message":"Demographics registered",
            //         "role":"podcaster"
            //     }
            // };
            if(res.data.message === 'Demographics registered' && res.data.hasOwnProperty('role')){
                posthog.capture('user_demographics_registered', {
                    role: res.data.role,
                });
                let route;
                if(res.data.role === 'podcaster'){
                    route = "/wizard/choice";
                } else {
                    const rawClub = sessionStorage.getItem("signup_club");
                    if (rawClub) {
                        try {
                            const club = JSON.parse(rawClub);
                            route = `/listener-podcast-club/${club.guid}`;
                        } catch { /* fall through */ }
                    }
                    sessionStorage.removeItem("signup_token");
                    sessionStorage.removeItem("signup_club");
                    route = route || '/listener-clubs';
                }
                navigate(route);
            }
            console.log("User registered:", res.data.message);
        } catch (err) {
            console.error("Signup error message:", err.response.data.message);
            setErrors(err.response.data.errors)
            setLoading(false);
        } finally {

        }
    };

    const handleSendEmail = async () => {
        setEmailSent(true)
    }

    useEffect(() => {
        if(process.env.NODE_ENV === 'development'){
            setFormData({
                role: "podcaster",
                country: "Ireland",
                phone: "0872989735",
                town: "Ardee",
            });
        }
    }, []);

    return (
        <>
            <Container>
                <Row>
                    <Col xs={12} className={'text-end my-3'}>
                        <LogOutButtonWithConfirmModal />
                    </Col>
                </Row>
            </Container>
            <Container className="d-flex justify-content-center align-items-center py-5">
                <Card style={{
                    width: '50%',
                    overflow: 'hidden',
                    margin: 0
                }}>
                    <Row className="g-0">
                        <Col>
                            <div className='p-3'>
                                <div className={'text-center'}>
                                    <AnimatedImage
                                        src="/img/podsy-logo-w-200.png"
                                        alt="Podsy Logo"
                                        loopMs={3000}      // speed of the float loop
                                        aberration={true}  // toggle chromatic aberration
                                        className="" // your sizing classes
                                    />
                                </div>
                                <Form className='text-left' onSubmit={handleSubmit}>
                                    <Row>
                                        <Col xs={12}>
                                            <p className="mb-0" style={{fontSize: '1rem'}}>
                                                Choose how you’re joining Podsy. <br/>We’ll take you to the right setup in the next step.
                                            </p>
                                        </Col>
                                        <Col xs={12} className="mb-3">
                                            <Form.Group className="" controlId="role">
                                                <Form.Label> </Form.Label>
                                                <Form.Select
                                                    name="role"
                                                    disabled={loading}
                                                    value={formData.role || ""}
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.role}
                                                >
                                                    <option value="">I’m here as a…</option>
                                                    <option value="listener">Listener</option>
                                                    <option value="podcaster">Podcaster</option>
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.role?.[0]}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        {/*<Col>*/}
                                        {/*    <Form.Group className="mb-2" controlId="country">*/}
                                        {/*        <Form.Label>Country</Form.Label>*/}
                                        {/*        <Form.Select*/}
                                        {/*            name="country"*/}
                                        {/*            value={formData.country || ""}*/}
                                        {/*            disabled={loading}*/}
                                        {/*            onChange={handleChange}*/}
                                        {/*            isInvalid={!!errors.country}*/}
                                        {/*        >*/}
                                        {/*            <option value="">-- Select Country --</option>*/}
                                        {/*            {englishSpeakingCountries.map((c) => (*/}
                                        {/*                <option key={c} value={c}>*/}
                                        {/*                    {c}*/}
                                        {/*                </option>*/}
                                        {/*            ))}*/}
                                        {/*        </Form.Select>*/}
                                        {/*        <Form.Control.Feedback type="invalid">*/}
                                        {/*            {errors.country?.[0]}*/}
                                        {/*        </Form.Control.Feedback>*/}
                                        {/*    </Form.Group>*/}
                                        {/*</Col>*/}
                                    </Row>
                                    {/*<Row>*/}
                                    {/*    <Col>*/}
                                    {/*        <Form.Group className="mb-3" controlId="phone">*/}
                                    {/*            <Form.Label>Phone</Form.Label>*/}
                                    {/*            <Form.Control*/}
                                    {/*                name={'phone'}*/}
                                    {/*                type="phone"*/}
                                    {/*                disabled={loading}*/}
                                    {/*                placeholder="Phone"*/}
                                    {/*                value={formData.phone}*/}
                                    {/*                onChange={handleChange}*/}
                                    {/*                isInvalid={!!errors.phone}*/}
                                    {/*            />*/}
                                    {/*            <Form.Control.Feedback type="invalid">*/}
                                    {/*                {errors.phone?.[0]}*/}
                                    {/*            </Form.Control.Feedback>*/}
                                    {/*        </Form.Group>*/}
                                    {/*    </Col>*/}
                                    {/*    <Col>*/}
                                    {/*        <Form.Group className="mb-3" controlId="town">*/}
                                    {/*            <Form.Label>Town</Form.Label>*/}
                                    {/*            <Form.Control*/}
                                    {/*                name={'town'}*/}
                                    {/*                type="text"*/}
                                    {/*                disabled={loading}*/}
                                    {/*                placeholder="Town"*/}
                                    {/*                value={formData.town}*/}
                                    {/*                onChange={handleChange}*/}
                                    {/*                isInvalid={!!errors.town}*/}
                                    {/*            />*/}
                                    {/*            <Form.Control.Feedback type="invalid">*/}
                                    {/*                {errors.town?.[0]}*/}
                                    {/*            </Form.Control.Feedback>*/}
                                    {/*        </Form.Group>*/}
                                    {/*    </Col>*/}
                                    {/*</Row>*/}
                                    <Row>
                                        {/*<Col>*/}
                                        {/*    <Button onClick={handleSendEmail} disabled={emailSent} className="w-100 mb-2" variant="light">*/}
                                        {/*        Send registration email*/}
                                        {/*    </Button>*/}
                                        {/*</Col>*/}
                                        <Col>
                                            <Button disabled={loading} className="w-100 mb-2" variant="primary" type="submit">
                                                {loading ? <FaSpinner className={"loading_spinner"} /> : 'Continue'}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </Container>
        </>
    );
};

export default Register;
